import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const SocialObjectiveInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Objetivo social relacionado al proyecto">
      {getFieldDecorator("socialObjective", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el objetivo social relacionado al proyecto."
          }
        ],
        initialValue: implementerProfile?.socialObjective
      })(
        <Input
          disabled={isBusy}
          id="socialObjective"
          name="socialObjective"
          placeholder="Objetivo social relacionado al proyecto"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
